<template>
  <sweet-modal ref="create_discount" title="Create Discount">
    <div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <div class="row">
              <div class="col">
                <label>{{ "amount" | t }}</label>
                <input class="form-control" v-model="newDiscount.value" />
              </div>
              <div class="col-auto">
                <label>{{ "currency" | t }}</label>
                <select
                  class="form-control"
                  v-model="newDiscount.discount_type"
                >
                  <option value="fixed">
                    <span v-if="customer">{{ customer.currency }}</span>
                  </option>
                  <option value="percentage">%</option>
                </select>
              </div>
              <div class="col-auto">
                <label>{{ "cause" | t }}</label>
                <select
                  class="form-control"
                  v-model="newDiscount.discount_cause"
                >
                  <option
                    v-for="(cause, idx) in discountCauses"
                    :value="cause"
                    :key="idx"
                  >
                    {{ cause | t }}
                  </option>
                </select>
              </div>
              <div class="col-auto">
                <label>{{ "source" | t }}</label>
                <select
                  class="form-control"
                  v-model="newDiscount.discount_source"
                >
                  <option
                    v-for="(source, idx) in billingSources"
                    :value="source"
                    :key="idx"
                  >
                    {{ source | t | titlecase }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>{{ "comment" | t }}</label>
            <textarea
              class="form-control"
              v-model="newDiscount.comment"
              rows="20"
            ></textarea>
          </div>
          <div class="text-right form-group">
            <button class="btn btn-primary" @click="createDiscount">
              {{ "save" | t }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import { DISCOUNT_CAUSES, BILLING_SOURCES } from "@/utils/billing";
import { handle } from "@/utils/alerts.js";
import Api from "@/store/jsonapi";

export default {
  props: {
    customer: Object,
  },
  data() {
    return {
      newDiscount: {
        value: 1,
        discount_type: "fixed",
        comment: "",
        discount_cause: "system_error",
        discount_source: "webshipper",
      },
      discountCauses: DISCOUNT_CAUSES,
      billingSources: BILLING_SOURCES,
    };
  },
  methods: {
    createDiscount: handle(async function () {
      let { data: discount } = await Api.create("discounts", {
        ...this.newDiscount,
        customer: this.customer,
      });

      this.newDiscount = {
        value: 1,
        discount_type: "fixed",
        comment: "",
      };

      this.$emit("discountCreated", discount);
      this.$refs.create_discount.close();
    }),
    open() {
      this.$refs.create_discount.open();
    },
    close() {
      this.$refs.create_discount.close();
    },
  },
};
</script>